export enum UserType {
    SuperAdmin,
    Admin,
    LocalWorker,
    Client
}